class Form {

    constructor() {

        $('form[data-ajax-form]').ssdForm();
        $('select[data-ssd-select]').ssdSelect();

    }

}

export default Form;


// WEBPACK FOOTER //
// ./resources/js/src/core/Form.js